/** Security Center icons by name (src/content/security/pages.js). */
import PropTypes from 'prop-types';
import {
  Activity, Bug, CreditCard, Database, KeyRound, Lock, PhoneCall, Server,
  Shield, ShieldAlert, ShieldCheck, Sparkles,
} from 'lucide-react';

export const SECURITY_ICONS = {
  Activity, Bug, CreditCard, Database, KeyRound, Lock, PhoneCall, Server,
  ShieldAlert, ShieldCheck, Sparkles,
};

export default function SecurityIcon({ name, className = 'h-5 w-5' }) {
  const Icon = SECURITY_ICONS[name] || Shield;
  return <Icon className={className} strokeWidth={1.5} aria-hidden />;
}
SecurityIcon.propTypes = { name: PropTypes.string, className: PropTypes.string };
